import variables from '../Utils/variables.json';

export const getUtdanningSiteBaseUrl = () => {
  const hostname = window.location.hostname;
  if (
    hostname === 'localhost' ||
    hostname === 'staging.utdanning.no' 
  ) {
    return variables.utdanningstaging;
  } else {
    return variables.utdanningprod;
  }
};

export const getUtdanningSiteUrl = (url) => {
  const base = getUtdanningSiteBaseUrl();
  return /^(http|https):\/\//.exec(url) ? url : base + url;
};


